import React, {Component} from "react"

import PaperBlock from "../../ui/PaperBlock"

import CreateFolderIcon from '@material-ui/icons/CreateNewFolder'
import CreateTemplateIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'
import EditTemplateIcon from '@material-ui/icons/BeachAccess'
import MoveToFolderIcon from '@material-ui/icons/LowPriority'
import { Button, Tooltip } from "@material-ui/core"

/**
 * selected
 * 
 * onCreateFolderClick(selected)
 * onCreateTemplateClick(selected)
 * onEditTemplateAttachmentsClick(selected)
 * onMoveToFolderClick(selected)
 * onEditClick(selected)
 * onDeleteClick(selected)
 */

class ControlPanel extends Component {

    render() {
        return <PaperBlock style={{display: "flex"}}>
            
            <Tooltip title="Создать папку"><div>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreateFolderClick === "function") {
                            this.props.onCreateFolderClick(this.props.selected)
                        }
                    }}
                >
                    <CreateFolderIcon />
                </Button>
            </div></Tooltip>

            <Tooltip title="Создать шаблон"><div>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreateTemplateClick === "function") {
                            this.props.onCreateTemplateClick(this.props.selected)
                        }
                    }}
                >
                    <CreateTemplateIcon />
                </Button>
            </div></Tooltip>

            <Tooltip title="Редактировать вложения"><div>
                <Button
                    disabled = {!(this.props.selected && this.props.selected.type === 1)}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditTemplateAttachmentsClick === "function") {
                            this.props.onEditTemplateAttachmentsClick(this.props.selected)
                        }
                    }}
                >
                    <EditTemplateIcon />
                </Button>
            </div></Tooltip>

            <Tooltip title="Переместить в папку"><div>
                <Button
                    disabled = {!this.props.selected}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onMoveToFolderClick === "function") {
                            this.props.onMoveToFolderClick(this.props.selected)
                        }
                    }}
                >
                    <MoveToFolderIcon />
                </Button>
            </div></Tooltip>

            <Tooltip title="Редактировать"><div>
                <Button
                    disabled = {!this.props.selected}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditClick === "function") {
                            this.props.onEditClick(this.props.selected)
                        }
                    }}
                >
                    <EditIcon />
                </Button>
            </div></Tooltip>

            <Tooltip title="Удалить"><div>
                <Button
                    disabled = {!this.props.selected}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onDeleteClick === "function") {
                            this.props.onDeleteClick(this.props.selected)
                        }
                    }}
                >
                    <DeleteIcon />
                </Button>
            </div></Tooltip>

        </PaperBlock>
    }

}

export default ControlPanel